import { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./app-shell.css";
import { useAuth } from "@/app/providers/AuthProvider";
import { useTenant } from "@/app/providers/TenantProvider";

const nav = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/brief/atlas", label: "Brief" },
  { to: "/plan", label: "Plan" },
  { to: "/evidence", label: "Evidence" },
  { to: "/report", label: "Report" },
];

export function AppShell() {
  const { isAuthenticated, signInUrl } = useAuth();
  const { orgSlug, isAppHost } = useTenant();

  useEffect(() => {
    if (!isAuthenticated || (!isAppHost && import.meta.env.PROD)) {
      window.location.href = signInUrl;
    }
  }, [isAuthenticated, isAppHost, signInUrl]);

  if (!isAuthenticated || (!isAppHost && import.meta.env.PROD)) {
    return null;
  }

  return (
    <div className="shell">
      <aside className="shell__side">
        <div className="shell__brand">
          <span className="shell__logo">CR</span>
          <div>
            <div className="shell__title">Crucible</div>
            <div className="shell__sub">
              {orgSlug ? `${orgSlug} · org` : "Multi-tenant app"}
            </div>
          </div>
        </div>
        <nav className="shell__nav">
          {nav.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive ? "shell__link shell__link--active" : "shell__link"
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  );
}